import React, { useContext, useEffect } from 'react'
import { useLazyQuery, NetworkStatus } from '@apollo/client'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import TableSkeleton from '../../../components/skeletons/TableSkeleton'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'
import { GET_FACTORY_MONITORING } from '../../../queries/factory'
import { formatNumber } from '../../../utils/Helpers'

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
})

export type IndustryMonitoring = {
  brand: string,
  device: string,
  items: number,
  deltaItems: number,
  averageValue: number,
  deltaAverageValue: number,
  orders: number,
  deltaOrders: number,
  income: number,
  deltaIncome: number
}

export default function GeneralMonitoringIndustries (): JSX.Element {
  const { filters } = useContext(FactoryFiltersContext)
  const classes = useStyles()

  const [getData, { loading, data, networkStatus }] = useLazyQuery(
    GET_FACTORY_MONITORING, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: {
        filters: { ...filters }
      }
    })
  }, [filters])

  if (networkStatus === NetworkStatus.refetch) return <TableSkeleton />
  if (loading || !data) return <TableSkeleton />
  if (!data.industryMonitoring) return <p>No data found</p>

  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Marca</TableCell>
            <TableCell align="right">Dispositivo</TableCell>
            <TableCell align="right">Volume de itens</TableCell>
            <TableCell align="right">%</TableCell>
            <TableCell align="right">Valor médio</TableCell>
            <TableCell align="right">%</TableCell>
            <TableCell align="right">Volume de pedidos</TableCell>
            <TableCell align="right">%</TableCell>
            <TableCell align="right">Receita</TableCell>
            <TableCell align="right">%</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.industryMonitoring.map((row: IndustryMonitoring) => (
            <TableRow key={`${row.brand}-${row.device}`}>
              <TableCell component="th" scope="row">
                {row.brand}
              </TableCell>
              <TableCell align="right">{row.device}</TableCell>

              <TableCell align="right">{row.items}</TableCell>
              <TableCell align="right">{formatNumber(row.deltaItems, 2)}</TableCell>
              <TableCell align="right">{formatNumber(row.averageValue, 2)}</TableCell>
              <TableCell align="right">{formatNumber(row.deltaAverageValue, 2)}</TableCell>
              <TableCell align="right">{row.orders}</TableCell>
              <TableCell align="right">{formatNumber(row.deltaOrders, 2)}</TableCell>
              <TableCell align="right">{formatNumber(row.income, 2)}</TableCell>
              <TableCell align="right">{formatNumber(row.deltaIncome, 2)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
